import * as yup from 'yup';

import { convertYupErrorToMessagesObject } from '@shared/utils/validation.utils';
import { inviteeEmailSchema } from '@shared/utils/validation.schemas';

export const inviteeEmailValidate = ({
    data,
}) => {
    const schema = yup.object().shape({
        email: inviteeEmailSchema,
    });

    return schema.validate(data, { abortEarly: false }).catch(
        error => Promise.reject(convertYupErrorToMessagesObject(error)),
    );
};
